<template>
  <section class="custom-activity-wrapper">
    <div class="custom-activity-add">
      <button class="btn btn-primary btn-sm" @click="addSession">Add</button>
      <button
        v-if="anyChecked"
        class="btn btn-primary btn-sm ms-2"
        @click="removeSession"
      >
        Remove
      </button>
    </div>
    <z-table
      :value="dailyProgress"
      sortBy="date"
      orderBy="asc"
      :columns="tableColumns"
      :isSingleRowDetail="false"
      class="table table-bordered table-striped"
    >
      <template v-slot:tbody="props">
        <td class="text-center">
          <input
            type="checkbox"
            :id="props.row.session_id"
            :checked="props.row.checked"
            @change="itemChecked"
            class="z-checkbox-small-centered"
          />
        </td>
        <td class="text-center">
          <img
            v-if="props.row.ActivityIcon !== null"
            :src="props.row.ActivityIcon"
            class="custom-icon"
            :title="props.row.ActivityName"
          />
        </td>
        <td>
          <button class="btn btn-link" @click="showSessionData(props.row)">
            {{ props.row.SessionDate }}
          </button>
        </td>
        <td>{{ props.row.DateUploaded }}</td>
        <td class="text-end">{{ props.row.Calories }}</td>
        <td class="text-end">
          {{ formatNumber(props.row.TotalZoneTime / 60) }}
        </td>
        <td class="text-end">
          {{ formatNumber(props.row.BelowZoneTime / 60) }}
        </td>
        <td class="text-end">{{ formatNumber(props.row.InZoneTime / 60) }}</td>
        <td class="text-end">
          {{ formatNumber(props.row.AboveZoneTime / 60) }}
        </td>
        <td class="text-center">
          <i v-if="showLiveFlag(props.row.ClassId)" class="fas fa-podcast"></i>
        </td>
      </template>
      <template v-slot:empty> Nothing found! </template>
    </z-table>
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'activity-week',
  components: {
    ZTable,
    ConfirmRemove,
  },
  data() {
    return {
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove:
        'Removing workouts cannot be undone. Are you sure you wish to remove this workout(s)?',
      actionConfirmRemove: null,
    }
  },
  computed: {
    ...mapGetters('usercardio', ['memberDailyProgress']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'text-center',
        },
        {
          field: 'SmoothFlag',
          label: '',
          sortable: false,
          class: 'text-center',
        },
        {
          field: 'DateUploaded',
          label: 'Date',
          sortable: false,
        },
        {
          field: 'SessionDate',
          label: 'Sync',
          sortable: false,
        },
        {
          field: 'Calories',
          label: 'Calories',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'TotalZoneTime',
          label: 'Total Time',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'BelowZoneTime',
          label: 'Below Zone',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'InZoneTime',
          label: 'In Zone',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'AboveZoneTime',
          label: 'Above Zone',
          sortable: false,
          class: 'text-end',
        },
        {
          field: 'ClassId',
          label: 'Live?',
          sortable: false,
          class: 'text-center',
        },
      ]
    },
    dailyProgress() {
      let _data = []
      if (this.memberDailyProgress) {
        _data = this.memberDailyProgress.dailyProgress
      }
      console.log('Daily Progress', _data)
      return _data
    },
    anyChecked() {
      let _any = false
      if (this.memberDailyProgress) {
        if (this.memberDailyProgress.dailyProgress) {
          if (Array.isArray(this.memberDailyProgress.dailyProgress)) {
            let found = this.memberDailyProgress.dailyProgress.find(
              (x) => x.checked
            )
            if (found) {
              _any = true
            }
          }
        }
      }
      return _any
    },
  },
  methods: {
    ...mapActions('usercardio', ['setMemberDailyProgressData']),
    formatNumber(value) {
      let _result = 0
      if (value !== '') {
        _result = parseFloat(value).toFixed(0)
      }
      return _result
    },
    itemChecked(e) {
      this.$nextTick(() => {
        let data = {
          id: parseInt(e.srcElement.id),
          checked: e.srcElement.checked,
        }
        this.setMemberDailyProgressData({
          name: 'checked',
          value: data,
        })
      })
    },
    closeModal() {
      this.actionConfirmRemove = null
    },
    removeSession() {
      this.actionConfirmRemove = true
    },
    performRemove() {
      this.actionConfirmRemove = null
      let ids = ''
      this.dailyProgress.forEach((element) => {
        if (element.checked) {
          if (ids !== '') {
            ids += ','
          }
          ids += parseInt(element.session_id)
        }
      })
      this.$emit('removeSessions', ids)
    },
    showSmoothFlag(flag) {
      let _show = false
      if (flag === '1') {
        _show = true
      }
      return _show
    },
    showLiveFlag(live) {
      let _show = false
      if (live !== '') {
        _show = true
      }
      return _show
    },
    showSessionData(row) {
      this.$emit('showSession', row)
    },
    addSession() {
      this.$emit('addSession')
    },
  },
}
</script>
<style scoped>
.custom-activity-wrapper {
  position: relative;
}
.custom-activity-add {
  position: absolute;
  left: 0;
  top: -50px;
}
.custom-flag {
  font-size: 0.9em;
}
.custom-icon {
  width: 32px;
  height: 32px;
}
</style>
